import { format, formatInTimeZone } from "date-fns-tz";
import { useAppSelector } from "../../../lib/redux/hooks";
import { formatDelay, formatFlightTime } from "../../../lib/types";
import { colors } from "../../../ui/color";
import { ClockIcon } from "../../../ui/icons/clockIcon";
import { InfoIcon } from "../../../ui/icons/infoIcon";
import { Spinner } from "../../../ui/molecoles/spinner";

export function ArrivalHistory() {
    const reportState = useAppSelector(state => state.report)

    if (reportState.findByIdStatus === "loading") {
        return (
            <div className={"flex justify-center items-center flex-grow"}>
                <Spinner />
            </div>
        )
    }

    return (
        <div className="w-full flex justify-between items-center gap-10">
            <div className="w-full bg-pas-200 rounded-[20px] flex flex-col gap-8 justify-start p-5 h-[460px]">
                <div className="flex flex-row items-center gap-3">
                    <InfoIcon size={24} color={colors.pas[800]} />
                    <span className="text-[16px] font-bold text-pas-800 leading-6">
                        Arrival flight information
                    </span>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-sm font-semibold text-pas-800">
                        Arrival airport
                    </span>
                    <span className="text-text-lg ">
                        {reportState.findByIdResponse?.flight_info.flight.arrival.airport.name + " (" + reportState.findByIdResponse?.flight_info.flight.arrival.airport.code_iata + ")"}
                    </span>
                </div>
                {
                    reportState.findByIdResponse?.flight_info.flight.history.diverted &&
                    <div className="flex flex-col gap-2">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Diverted to
                        </span>
                        <span className="text-text-lg ">
                            {
                                reportState.findByIdResponse?.flight_info.diverted_flight.arrival.airport.name && reportState.findByIdResponse?.flight_info.diverted_flight.arrival.airport.code_iata ?
                                    reportState.findByIdResponse?.flight_info.diverted_flight.arrival.airport.name + " (" + reportState.findByIdResponse?.flight_info.diverted_flight.arrival.airport.code_iata + ")" :
                                    "-"
                            }
                        </span>
                    </div>
                }
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Date
                        </span>
                        <span className="text-text-lg ">
                            {
                                reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.scheduled_in_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                    format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.scheduled_in_tz, "dd/MM/yyyy") :
                                    "-"
                            }
                        </span>
                    </div>
                    {/* <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-bold text-pas-800">
                            Aircraft
                        </span>
                        <span className="text-text-lg ">
                            {reportState.findByIdResponse?.flight_info.flight.aircraft_name}
                        </span>
                    </div> */}
                </div>
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Terminal
                        </span>
                        <span className="text-text-lg ">
                            {reportState.findByIdResponse?.flight_info.flight.arrival.terminal_and_gate.terminal_destination === "" ? "-" : reportState.findByIdResponse?.flight_info.flight.arrival.terminal_and_gate.terminal_destination}
                        </span>
                    </div>
                    <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Gate
                        </span>
                        <span className="text-text-lg ">
                            {reportState.findByIdResponse?.flight_info.flight.arrival.terminal_and_gate.gate_destination !== "" ? reportState.findByIdResponse?.flight_info.flight.arrival.terminal_and_gate.gate_destination : "-"}
                        </span>
                    </div>
                </div>
            </div>
            <div className="w-full bg-pas-200 rounded-[20px] flex flex-col gap-8 justify-start p-5 h-[460px]">
                <div className="flex flex-row items-center gap-3">
                    <ClockIcon size={24} color={colors.pas[800]} />
                    <span className="text-[16px] font-bold text-pas-800 leading-6">
                        Arrival times
                    </span>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-lg font-bold text-pas-800">
                        Flight runway times
                    </span>
                    <div className="flex flex-row justify-start">
                        <div className="flex flex-col gap-2 w-full">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Scheduled on
                            </span>
                            <span className="text-text-lg ">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.scheduled_on_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.scheduled_on_tz, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse.flight_info.flight.arrival.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                        <div className="flex flex-col gap-2 w-full items-start">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Actual on
                            </span>
                            <span className="text-text-lg ">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.actual_on_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.actual_on_tz, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-lg font-bold text-pas-800">
                        Flight gate times
                    </span>
                    <div className="flex flex-row justify-start">
                        <div className="flex flex-col gap-2 w-full">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Scheduled in
                            </span>
                            <span className="text-text-lg ">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.scheduled_in_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.scheduled_in_tz, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                        <div className="flex flex-col gap-2 w-full items-start">
                            <span className="text-text-sm font-semibold text-pas-800">
                                Actual in
                            </span>
                            <span className="text-text-lg ">
                                {
                                    reportState.findByIdResponse && format(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.actual_in_tz, "yyyy-MM-dd") !== "0001-01-01" ?
                                        formatInTimeZone(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.actual_in_tz, reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone, "HH:mm") + " " + reportState.findByIdResponse?.flight_info.flight.arrival.airport.timezone_abbr :
                                        "-"
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div className="flex flex-row justify-start">
                    <div className="flex flex-col gap-2 w-full">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Runway delay
                        </span>
                        <span className="text-text-lg ">
                            {
                                (reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.runway_delay === "" || reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.runway_delay === "0s") ?
                                    "-" :
                                    formatDelay(reportState.findByIdResponse?.flight_info.flight.arrival.flight_runway_times.runway_delay!)
                            }
                        </span>
                    </div>
                    <div className="flex flex-col gap-2 w-full items-start">
                        <span className="text-text-sm font-semibold text-pas-800">
                            Arrival delay
                        </span>
                        <span className="text-text-lg ">
                            {
                                (reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.arrival_delay === "" || reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.arrival_delay === "0s") ?
                                    "-" : formatDelay(reportState.findByIdResponse?.flight_info.flight.arrival.flight_gate_times.arrival_delay!)
                            }
                        </span>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <span className="text-text-sm font-semibold text-pas-800">
                        {"Flight time"}
                    </span>
                    <span className="text-text-lg ">
                        {formatFlightTime(reportState.findByIdResponse?.flight_info.flight.arrival.flight_time!)}
                    </span>
                </div>
            </div>
        </div>
    )
}